export default "__VITE_ASSET__B_1lTzZ9__"